import { render, staticRenderFns } from "./EditSpaceName.vue?vue&type=template&id=ea8b44d6"
import script from "./EditSpaceName.vue?vue&type=script&lang=js"
export * from "./EditSpaceName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports